(function () {
  'use strict';
  var adapter = window.MJCMeguri;
  if (!adapter || !adapter.behaviorEnabled || adapter.status() === 'disabled' || window.MJCMeguriMinimalPageLoaded) return;
  window.MJCMeguriMinimalPageLoaded = true;
  var config;
  try { config = JSON.parse(document.querySelector('[data-meguri-config]').textContent); } catch (e) { return; }
  var pageSeen = false, productSeen = false;
  function view() {
    try {
      if (document.visibilityState !== 'visible' || !adapter.allowed()) return;
      if (!pageSeen) pageSeen = adapter.emit('page_view', { page_type: config.pageType });
      if (!productSeen && config.pageType === 'product') {
        productSeen = adapter.emit('product_view', { product_id: config.productId, variant_id: config.variantId });
      }
    } catch (e) { /* Observation must not interrupt the storefront. */ }
  }
  adapter.onConsent(view);
  document.addEventListener('visibilitychange', view);
  window.addEventListener('pageshow', view);
})();
